import { startCase, uniqBy, sortBy } from "lodash-es";

export default class Permissions {
  static getFilteredPermissions = (permissions) => {
    return permissions.filter((p) => {
      return !p.name.includes("manage");
    });
  };

  static getOptionsFromPermissions = (permissions) => {
    return permissions.map((p) => {
      return {
        label: startCase(p.name),
        value: p.id,
      };
    });
  };

  static getFulfillmentPermissionOptions = (permissions) => {
    const filteredPermissions = Permissions.getFilteredPermissions(permissions);
    return Permissions.getOptionsFromPermissions(filteredPermissions);
  };

  static getSecondClosetPermissionOptions = (permissions) => {
    const sortedPermissions = sortBy(permissions, (p) => !p.name.includes("manage"));
    return Permissions.getOptionsFromPermissions(sortedPermissions);
  };

  static getPermissionIdsArray = (permissions) => {
    const uniquePermissions = uniqBy(permissions, "name");
    return uniquePermissions.reduce((acc, cv) => {
      acc.push(cv.id);
      return acc;
    }, []);
  };
}
